const ufeApi = require('services/api/ufeApi');

function challengeMessage(token, body) {
    const sdnDomain = Sephora.configurationSettings.sdnDomainBaseUrl;
    const url = `${sdnDomain}/v1/message/GameStatus`;

    return ufeApi
        .makeRequest(url, {
            method: 'POST',
            headers: {
                'Content-type': 'application/json',
                authorization: `Bearer ${token}`
            },
            body: JSON.stringify(body)
        })
        .then(data => data);
}

module.exports = { challengeMessage };
